var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0571 2.93693L6.20587 1.78591L7.7952 3.37835L5.86673 5.31225L6.75782 6.20508L9.57737 3.37835L6.20587 0.000257492L4.16602 2.0441L5.0571 2.93693Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1304 6.23766L1.69739 4.51696L0 6.21767L1.72399 7.94336L5.1304 6.23766Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67039 5.14258L3.37118 2.83888L2.60645 3.60678L5.67039 5.14258Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63379 8.85807L3.37193 9.59766L5.59133 7.37558L2.63379 8.85807Z",
    fill: "#7A7A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4998 6.21L8.37793 7.08984L9.25606 6.20999L8.37793 5.33015L7.4998 6.21Z",
    fill: "#7A7A7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91781 9.91157L6.20627 10.6245L5.05417 9.47182L4.16309 10.3646L6.20627 12.4102L7.8089 10.8044L6.91781 9.91157Z",
    fill: "#7A7A7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86719 7.09905L7.3152 8.54989L8.68675 9.92578L9.57783 9.03295L6.75661 6.20622L5.86719 7.09905Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvGray);
export default __webpack_public_path__ + "static/media/IvGray.e049e21f35a1c302ebfa90186af44e35.svg";
export { ForwardRef as ReactComponent };